import React, { Component } from 'react';
import {connect} from 'react-redux';
import classNames from "classnames";
import {Flipped} from "react-flip-toolkit";

import {emptyCategory} from '../actions'
import {bindActionCreators} from "redux";
import {onElementAppear, onElementExit} from '../utils'

class CategoryInformationBox extends Component{
    render() {
        const containerClasses = classNames(
            'search_box',
            'information_box',
            'category_information_box'
        );

        return (
            <Flipped
                flipId={`category_information_box`}
                onDelayedAppear={onElementAppear}
                onExit={onElementExit}
                key={`category_information_box`}
                delay={3}
                translate
                opacity
            >
                <div className={containerClasses}>
                    <div className={"exh4"}>Catégorie selectionnée</div>
                    <div>{this.props.category.name}</div>
                     <button onClick={() => this.props.emptyCategory()}>Changer de catégorie</button>
                </div>
            </Flipped>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        category:state.category
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        emptyCategory
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryInformationBox)